module.exports = __webpack_public_path__ + "media/src/assets/Images/AppSectionImage-b5750b8be388e1d639e34924cf8ce228.svg";